import { render, staticRenderFns } from "./assetFlow.vue?vue&type=template&id=24f297b4&scoped=true&"
import script from "./assetFlow.vue?vue&type=script&lang=js&"
export * from "./assetFlow.vue?vue&type=script&lang=js&"
import style0 from "./assetFlow.vue?vue&type=style&index=0&id=24f297b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f297b4",
  null
  
)

export default component.exports